import { result } from "lodash";
import stateStore from "../store/stateStore";
import errMsgService from "../services/common/errMsgService";
import rootScope from "../store/rootScopeStore";
import constMap from "../const/const";

// 半角（1byte）か全角（2byte）文字なのか判別する
export const calcInputSize = (str) => {
    if (isEmpty(str)) {
        return 0;
    }
    let length = 0;
    for (let i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
            length += 1;
        } else {
            length += 2;
        }
    }
    return length;

};

/**
 * 数値端数処理
 * @param {*} number 端数処理対象の数値
 * @param {*} fractionFlag 端数処理flg(四捨五入、切捨て、切上げ)
 * @param {*} fractionDigit 端数行(1: 小数点第一位、2:小数点第二位、 …)
 * @returns 
 */
export const fractionNumber = (number, fractionFlag, fractionDigit) => {

    // 金額端数区分情報を取得する。
    const krage = rootScope.kbn["GAKUHASUKBN"].KRAGE.code;
    const krsute = rootScope.kbn["GAKUHASUKBN"].KRSUTE.code;
    const sishgnyu = rootScope.kbn["GAKUHASUKBN"].SISHGNYU.code;

    // エラーメッセージ登録/削除用のオブジェクト
    const errFractionNumber = {
        name: "fractionNumber" + number + fractionFlag + fractionDigit
    };

    let resultNumber = Number(number);
    // マイナス値の場合、絶対値を取り出す
    let isMinus = false;
    if (resultNumber < 0) {
        resultNumber = Math.abs(resultNumber);
        isMinus = true;
    }

    // 端数行で端数処理する際に使用する変数
    const exponentOfTen = Math.pow(10, fractionDigit);

    // 切り上げ
    if (fractionFlag == krage) {
        resultNumber = Math.ceil(resultNumber * exponentOfTen) / exponentOfTen;
        // エラーメッセージ解除
        errMsgService.delMsgLabel(errFractionNumber);
    }
    // 切り捨て
    else if (fractionFlag == krsute) {
        resultNumber = Math.floor(resultNumber * exponentOfTen) / exponentOfTen;
        // エラーメッセージ解除
        errMsgService.delMsgLabel(errFractionNumber);
    }
    // 四捨五入
    else if (fractionFlag == sishgnyu) {
        resultNumber = Math.round(resultNumber * exponentOfTen) / exponentOfTen;
        // エラーメッセージ解除
        errMsgService.delMsgLabel(errFractionNumber);
    }
    // 端数処理flgが切り上げ、切捨て、四捨五入以外の場合エラー
    else {
        resultNumber = 0;
        // エラーメッセージ登録：番号9267「金額端数区分が対象外です。」
        errMsgService.addMsgLabel("ESYS0370", errFractionNumber);
    }

    // マイナスを戻す
    if (isMinus) {
        resultNumber = -resultNumber;
    }

    return resultNumber;
};

//現在のタブINDEXを把握し、次の有効なタブINDEXを取得
const focusMove = (doc, inputlist, isForward) => {
    try {
        if (!!doc.activeElement) {
            if (!!inputlist[doc.activeElement.name]) {
                const currentidx = inputlist[doc.activeElement.name].tabindex;

                const nextidx = currentidx + (isForward ? 1 : -1);

                for (let i = 0; i < Object.keys(inputlist).length; i++) {
                    const obj = inputlist[Object.keys(inputlist)[i]].ref.current;
                    if (!!obj
                        && !obj.readOnly
                        && inputlist[Object.keys(inputlist)[i]].tabindex === nextidx) {
                        //focus対象のコントールにフォーカス
                        obj.focus();
                        if (!!obj && !!obj.value && !!obj.value.length)
                            obj.setSelectionRange(0, obj.value.length);
                        break;
                    }

                }

            }
        }

    } catch (err) {
        console.log(err);
    }
}

export const keyfocuscontrol = (document, event, inputdata) => {

    switch (event.keyCode) {
        case "7":
            break;
        case 37://left
            // focusMove(document,inputdata,false);
            break;
        case 38://up
            event.preventDefault();
            focusMove(document, inputdata, false);
            break;
        case 39://right
            // focusMove(document,inputdata,true);

            break;
        case 13://enter
        case 40://down
            event.preventDefault();
            focusMove(document, inputdata, true);

            break;
    }
}

export const formatDateToText = (pdate, format = "yyyy/MM/dd") => {
    let dt = new Date(pdate);
    let yyyy = dt.getFullYear();
    let MM = ('00' + (dt.getMonth() + 1)).slice(-2);
    let dd = ('00' + dt.getDate()).slice(-2);
    let hh = ('00' + dt.getHours()).slice(-2);
    let mm = ('00' + dt.getMinutes()).slice(-2);
    let ss = ('00' + dt.getSeconds()).slice(-2);

    format = format.replace('yyyy', yyyy);
    format = format.replace('MM', MM);
    format = format.replace('dd', dd);
    format = format.replace('hh', hh);
    format = format.replace('mm', mm);
    format = format.replace('ss', ss);
    return format;
}

export const showDialog = (flag = null) => {
    const dialog = document.body.querySelector('#printLoadMask');
    if (dialog) {
        switch (flag) {
            case 'off':
                dialog.style.display = 'none';
                dialog.classList.remove("loading-visibled");
                break;
            default:
                dialog.style.display = 'flex';
                dialog.classList.add("loading-visibled");
                break;
        }
    }
}

/**
 * 引数がundefinedか判定します。
 * 
 * @param {any} arg 判定対象
 * @returns true: undefinedである, false: undefinedでない
 */
export const isUndefined = (arg) => {
    if (typeof arg == "undefined") return true;
    return false;
}

/**
* 引数がundefinedでないか判定します。
* 
* @param {any} arg 判定対象
* @returns  true: undefinedでない, false: undefinedである
*/
export const isNotUndefined = (arg) => {
    return !isUndefined(arg);
}


/**
 * 引数がundeifned, null, 空文字のいずれかであるか判定します。
 *
 * @param arg 判定対象
 * @returns true: undeifned, null, 空文字のいずれかである
 */
export const isEmpty = (arg) => {

    if (isUndefined(arg)) return true;
    if (isNull(arg)) return true;
    if (arg === "") return true;
    if (isEmptyObject(arg)) return true;
    if (Array.isArray(arg)) {
        return arg.length === 0;
    }
    return false;
}

/**
* 引数がundeifned, null, 空文字のどれとも一致しないか判定します。
* 
* @param {any} arg 判定対象
* @returns true:undeifned, null, 空文字のどれとも一致しないか
*/
export const isNotEmpty = (arg) => {
    return !isEmpty(arg);
}

/**
 * 引数がnullか判定します。
 *
 * @param arg 判定対象
 * @returns true:nullである, false:nullでない
 */
export const isNull = (arg) => {
    if (arg === null) return true;
    return false;
}

/**
 * 引数がnullでないか判定します。
 *
 * @param arg 判定対象
 * @returns true: nullでない, false: nullである
 */
export const isNotNull = (arg) => {
    return !isNull(arg);
}

/**
 * 引数のオブジェクトが空か判定します。
 *
 * @param arg 判定対象
 * @returns true: 空である
 */
export const isEmptyObject = (obj) => {
    return isType(obj, "Object") && Object.keys(obj).length <= 0;
}

// JavaScriptオブジェクトの型をチェック
export const isType = (obj, type) => {
    const clas = Object.prototype.toString.call(obj).slice(8, -1);
    return obj !== undefined && obj !== null && clas === type;
}

export const getMsg = (id, params) => {
    let strMessage = rootScope.Message[id][1].replaceAll("\\n","\n").replaceAll("\\r","\r");
    if (isNotEmpty(params)) {
        params.forEach((param, i) => {
            strMessage = strMessage.split(`{${i}}`).join(param);
        });
    }
    return strMessage;
}

// 独自ソート処理(null、空文字が下に来るようにした)
export const mySort = (data, cols) => {
    return data.sort((a, b) => {
        const res = 0;
        cols.map((col, idx) => {
            if (res !== 0) return;
            if ((a[col] !== null && a[col] !== "") && (b[col] == null || b[col] === "")) res = -1;
            else if ((a[col] === null || a[col] === "") && (b[col] !== null && b[col] !== "")) res = 1;
            else if (a[col] < b[col]) res = -1;
            else if (a[col] > b[col]) res = 1;
        })
        return res;
    });
};

/**
 * 日付文字列を比較してlaterよりboforeのほうが小さい場合、trueを返す。
 * @param from 日付文字列(YYYY/MM/DD)
 * @param to 日付文字列(YYYY/MM/DD)
 * @returns true:NG, false:OK
 */
export const isLaterValid = (later, bofore) => {

    let ret = false;

    const laterDate = new Date(later);
    const boforeDate = new Date(bofore);

    //Date型比較
    if (laterDate.getTime() > boforeDate.getTime()) {
        ret = true;
    }
    return ret;
}

export const stringToDate = (valueString) => {
    let mask;
    let temp;
    let dateString = '';
    let monthString = '';
    let yearString = '';
    let j = 0;
    const inputFormat = 'yyyy/MM/dd';
    const n = inputFormat.length;
    let i;
    for (i = 0; i < n; i++, j++) {
        temp = '' + valueString.charAt(j);
        mask = '' + inputFormat.charAt(i);

        if (mask === 'M') {
            if (isNaN(+(temp)) || temp === ' ') {
                j--;
            } else {
                monthString += temp;
            }
        } else if (mask === 'd' || mask === 'D') {
            if (isNaN(+(temp)) || temp === ' ') {
                j--;
            } else {
                dateString += temp;
            }
        } else if (mask === 'y' || mask === 'Y') {
            yearString += temp;
        } else if (!isNaN(+(temp)) && temp !== ' ') {
            return null;
        }
    }

    temp = '' + valueString.charAt(inputFormat.length - i + j);
    if (!(temp === '') && temp !== ' ') {
        return null;
    }

    const monthNum = Number(monthString);
    const dayNum = Number(dateString);
    let yearNum = Number(yearString);

    if (isNaN(yearNum) || isNaN(monthNum) || isNaN(dayNum)) {
        return null;
    }

    if (yearString.length === 2 && yearNum < 70) {
        yearNum += 2000;
    }

    const newDate = new Date(yearNum, monthNum - 1, dayNum);

    if (dayNum !== newDate.getDate() || monthNum - 1 !== newDate.getMonth()) {
        return null;
    }

    return newDate;
}

export const dateToString = (value, outputFormat) => {
    if (!value) {
        return '';
    }
    let date = value.getDate().toString();
    if (date.length < 2) {
        date = '0' + date;
    }

    let month = (value.getMonth() + 1).toString();
    if (month.length < 2) {
        month = '0' + month;
    }

    const year = value.getFullYear().toString();

    let output = '';
    let mask;

    const n = outputFormat !== null ? outputFormat.length : 0;
    for (let i = 0; i < n; i++) {
        mask = outputFormat.charAt(i);

        if (mask === 'M') {
            if (outputFormat.charAt(i + 1) === '/' && value.getMonth() < 9) {
                output += month.substring(1) + '/';
            } else {
                output += month;
            }
            i++;
        } else if (mask === 'd' || mask === 'D') {
            if (outputFormat.charAt(i + 1) === '/' && value.getDate() < 10) {
                output += date.substring(1) + '/';
            } else {
                output += date;
            }
            i++;
        } else if (mask === 'y' || mask === 'Y') {
            if (outputFormat.charAt(i + 2) === 'y' || outputFormat.charAt(i + 2) === 'Y') {
                output += year;
                i += 3;
            } else {
                output += year.substring(2, 4);
                i++;
            }
        } else {
            output += mask;
        }
    }
    return output;
}

// 画面幅チェック
export const checkIsMobile = () => {
    const isMobile = (window.innerWidth < 992);
    return isMobile;
}

export const isNumber = (val) => {
    return isFinite(val);
}

export default focusMove;
